import { PlainSearchParameters } from 'algoliasearch-helper'

import { parseIndexSelectorParams } from '@app-lib/search-index.lib'
import {
    mapFacetFilters,
    normalizeFacetFilters,
} from '@app-domains/meilisearch/mappers/facet-filter.mapper'
import { mapNumericFilters } from '@app-domains/meilisearch/mappers/numeric-filter.mapper'
import { indexNameToSort } from '@app-domains/meilisearch/mappers/product-sort.mapper'
import {
    ProductFilterInput,
    ProductSearchInput,
} from '@app-domains/meilisearch/types/product-search.types'
import { decodeMeilisearchContext } from '@app-domains/meilisearch/types/search-request-context.types'

export function mapInstantSearchRequest(
    indexName: string,
    params: PlainSearchParameters,
    isNlMarket: boolean,
): ProductSearchInput {
    const { locale } = parseIndexSelectorParams(indexName)
    const context = decodeMeilisearchContext(params as Record<string, unknown>)
    const facetFilters = normalizeFacetFilters(params.facetFilters as string | string[] | undefined)
    const widgetFilters = mapFacetFilters(facetFilters)
    const numericFilters = mapNumericFilters(params.numericFilters as string | string[] | undefined)
    const filters = mergeFilters(context.baseFilters, widgetFilters, numericFilters)
    const facets = normalizeFacetsList(params.facets)

    return {
        query: params.query ?? '',
        locale,
        page: (params.page ?? 0) + 1,
        perPage: params.hitsPerPage !== undefined ? params.hitsPerPage : 24,
        sort: indexNameToSort(indexName, isNlMarket),
        filters,
        facets,
    }
}

function normalizeFacetsList(facets: string | readonly string[] | undefined): string[] | undefined {
    if (facets == null) {
        return undefined
    }

    return typeof facets === 'string' ? [facets] : [...facets]
}

function mergeFilters(...groups: ProductFilterInput[][]): ProductFilterInput[] {
    const seen = new Set<string>()

    return groups.flat().filter((filter) => {
        const key = `${filter.attribute}:${filter.operator}:${filter.values.join('|')}`

        if (seen.has(key)) {
            return false
        }

        seen.add(key)

        return true
    })
}
